import { render, staticRenderFns } from "./RegionView.vue?vue&type=template&id=2dcc1ea7&scoped=true"
import script from "./RegionView.vue?vue&type=script&lang=js"
export * from "./RegionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc1ea7",
  null
  
)

export default component.exports